import { createContext } from 'react';
import type { EventScope } from '../core/EventScope';

export const EventScopeContext = createContext<EventScope | null>(null);
